
function Failure() {
  return (
    	<section class="ser_v_araeea">
		<div class="container">
		   <div class="thk_you_fr">
		    <div class="mdlss">
		     <span class="tikk reg_bg"><i class="fa fa-times"></i></span>
		     <h4>Failed</h4>
			 <p>You Data has not been  successful.</p>
		    </div>
		   </div>
		</div>
	</section>
  )
}

export default Failure